"use client";

import React from "react";
import { ArrowRight, Sparkles } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ConsultationCta() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="225498" id="immediate-access" className="bg-background text-foreground relative flex min-h-[80vh] items-center justify-center overflow-hidden py-24 px-4 sm:px-6 lg:px-8">
      {}
      <div className="absolute inset-0 z-0 opacity-40">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 h-[500px] w-[500px] rounded-full bg-primary/20 blur-[120px]" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 h-[300px] w-[300px] rounded-full bg-accent/10 blur-[80px]" />
        <div className="absolute inset-0 opacity-[0.05]" style={{
        backgroundImage: 'radial-gradient(circle at center, #ffffff 1px, transparent 1px)',
        backgroundSize: '32px 32px'
      }} />
      </div>

      <div ref={ref} className={`relative z-10 w-full max-w-4xl transition-all duration-1000 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`}>
        {}
        <div className="relative rounded-3xl border border-white/10 bg-card/30 p-8 shadow-2xl shadow-primary/10 backdrop-blur-2xl sm:p-16 text-center ring-1 ring-white/5">
          
          <div className="mx-auto flex max-w-3xl flex-col items-center">
            {}
            <Badge variant="outline" className="mb-8 border-primary/30 bg-primary/5 px-4 py-1.5 text-sm font-medium text-primary shadow-sm">
              <Sparkles className="mr-2 size-4" />
              Ready to Onboard
            </Badge>

            {}
            <h2 className="font-default mb-6 text-balance text-4xl font-bold leading-tight tracking-tight sm:text-5xl lg:text-6xl">
              Start your managed experience <br className="hidden sm:block" />
              <span className="bg-gradient-to-r from-primary to-accent-foreground bg-clip-text text-transparent">in 60 seconds.</span>
            </h2>

            <p className="font-default mb-10 max-w-2xl text-lg text-muted-foreground sm:text-xl">
              OceanWallet transforms digital payments into a seamless coastal thread. Secure, intelligent, and immediately accessible through our managed OceanClaw control plane.
            </p>

            {}
            <div className="flex flex-col items-center justify-center gap-4 sm:flex-row">
              <Link to="#">
                <Button size="lg" className="group h-14 rounded-full bg-primary text-primary-foreground px-8 text-lg font-semibold shadow-lg shadow-primary/20 transition-all hover:scale-105 hover:shadow-xl hover:shadow-primary/40">
                  Download on the App Store
                  <ArrowRight className="ml-2 size-5 transition-transform group-hover:translate-x-1" />
                </Button>
              </Link>
            </div>
            
            <p className="font-default mt-6 text-sm text-muted-foreground/60 tracking-wider uppercase">
              SOC2 Compliant • Fully Encrypted • Managed Infrastructure
            </p>
          </div>
        </div>
      </div>
    </section>;
}